import { Trans } from '@lingui/react/macro'

import { useGetConfig } from '@jotta/grpc-connect-client/config'
import type { SupportChannel } from '@jotta/grpc-connect-openapi/config'
import { showNewIntercomMessage } from '@jotta/intercom'
import type { PartialMessage } from '@jotta/types/compat'
import { exhaustiveGuard } from '@jotta/utils/exhaustive'

import { LoadingOverlay } from '../../Layout/LoadingOverlay/LoadingOverlay'

function SupportChannelRow({
  channel,
}: {
  channel: PartialMessage<SupportChannel>
}) {
  if (!channel.type) {
    return null
  }

  switch (channel.type.case) {
    case 'email':
      return (
        <a className="link" href={`mailto:${channel.type.value.emailAddress}`}>
          {channel.type.value.emailAddress}
        </a>
      )
    case 'intercom':
      return (
        <button
          onClick={showNewIntercomMessage}
          className="btn btn-primary w-full px-8"
        >
          <Trans>Start a chat with support</Trans>
        </button>
      )
    case 'phone':
      return (
        <p>
          <Trans>Phone support:</Trans>&nbsp;
          {channel.type.value.phoneNumberFormatted}
        </p>
      )
    case 'web':
      return (
        <a
          href={channel.type.value.url}
          className="link"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>Help center</Trans>
        </a>
      )
    case undefined:
      throw new Error('undefined')
    default:
      return exhaustiveGuard(channel.type)
  }
}

export function SupportChannels({
  customerGroupOverride,
}: {
  customerGroupOverride?: string
}) {
  const { data, isPending } = useGetConfig(customerGroupOverride)
  return (
    <div className="flex flex-col items-center gap-4">
      <LoadingOverlay id="SupportChannels" open={isPending} />
      {data?.brandingInfo?.supportChannels?.map((channel, i) => (
        <SupportChannelRow key={channel.type?.case} channel={channel} />
      ))}
    </div>
  )
}
